import { PropertyExampleListItem } from './property-example-list-item'
import { SuccessfullyConcludedDealItem } from '../../../schema/contract'

const SuccessfullyConcludedDealList = (props: {
  list: SuccessfullyConcludedDealItem[]
  isVertical?: boolean
  background: 'gray' | 'white'
  onItemClick?: (item: SuccessfullyConcludedDealItem) => void
  currentVisibleItem?: SuccessfullyConcludedDealItem | null
  isMobile?: boolean
  selectedItemId?: string
  noSelectedMode?: boolean
}) => {
  const itemsToRender =
    props.isMobile && props.currentVisibleItem
      ? [props.currentVisibleItem]
      : props.list

  return (
    <>
      {itemsToRender.map((item) => {
        const originalIndex = props.list.findIndex(
          (listItem) => listItem.id === item.id
        )
        const isSelected = props.selectedItemId === `marker-${originalIndex}`
        return (
          <PropertyExampleListItem
            key={`contract-${originalIndex}`}
            item={item}
            isVertical={props.isVertical}
            onClick={props.onItemClick && (() => props.onItemClick?.(item))}
            isSelected={isSelected}
            background={props.background}
            noSelectedMode={props.noSelectedMode}
          />
        )
      })}
    </>
  )
}

export default SuccessfullyConcludedDealList
